<div *ngIf="model" class="flex-column middle justify section container">
    <div class="target-selector-row">
    <mat-form-field *ngIf="visibleDeviceDropDown" class="mat-pickers fields">
        <mat-label> Device </mat-label>
        <mat-select [value]="device$ | async" (valueChange)="deviceUuid$.next($event.uuid)">
            <mat-option *ngFor="let device of devices$ | async" [value]="device">
                {{ device.name }}
            </mat-option>
        </mat-select>
    </mat-form-field>
        <mat-form-field class="mat-pickers fields">
            <mat-label> Material Type </mat-label>
            <mat-select [value]="selectedMaterialType" (valueChange)="onMaterialTypeChange($event)">
                <mat-option [value]="defaultMaterialType">
                    Default Device Target
                </mat-option>
                <mat-option *ngFor="let materialType of materialTypeOptions" [value]="materialType">
                    {{ materialType }}
                </mat-option>
            </mat-select>
        </mat-form-field>
    </div>
    <div>
        <div class="form-content content-container">
            <div class="slide-toggle-box">
                <mat-slide-toggle [(ngModel)]="preferCustomSizes" class="example-margin" color="primary"
                    [checked]="preferCustomSizes">
                    Apply Custom Sizes Over Regular Target Intervals
                </mat-slide-toggle>
            </div>
            <div class="content-container target-content">
                <table mat-table [dataSource]="sizeOptions" class="mat-elevation-z8 scroll">
                    <ng-container matColumnDef="targetSize">
                        <th mat-header-cell *matHeaderCellDef>Target Size</th>
                        <td mat-cell *matCellDef="let element">
                            <mat-form-field>
                                <measurement-input type="particleSize" [unitSystem]="(particleSizeUnitSystem$|async)"
                                    [(ngModel)]="element.targetSize" [value]="element.targetSize"></measurement-input>
                            </mat-form-field>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="targetMinPr">
                        <th mat-header-cell *matHeaderCellDef>Target Percentage Range (%)</th>
                        <td mat-cell *matCellDef="let element">
                            <mat-slider min="0" max="100" step="1" style="width: 88%;" discrete>
                                <input matSliderStartThumb [(ngModel)]="element.targetMinPr">
                                <input matSliderEndThumb [(ngModel)]="element.targetMaxPr">
                            </mat-slider>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="action" class="action-column">
                        <th mat-header-cell *matHeaderCellDef>Action</th>
                        <td mat-cell *matCellDef="let element">
                            <button color="primary" class="action-btn" (click)="removeSizeRange(element)">
                                <mat-icon svgIcon="trash"> </mat-icon>
                            </button>
                        </td>
                    </ng-container>
                    <tr mat-header-row *matHeaderRowDef="['targetSize', 'targetMinPr', 'action']"></tr>
                    <tr mat-row *matRowDef="let row; columns: ['targetSize', 'targetMinPr', 'action']"></tr>
                </table>
            </div>
        </div>
        <div style="text-align: center; margin-top: 16px;">
            <button mat-flat-button color="primary" (click)=" toggleAddSizeRange()">
                Add New
            </button>
        </div> <br />
        <div *ngIf="showAddSizeRange" style="width: 100%; overflow: hidden;" class="flex-row justify">
            <mat-form-field class="min-13 container">
                <mat-label>Target Size</mat-label>
                <measurement-input type="particleSize" [unitSystem]="(particleSizeUnitSystem$|async)"
                    [(ngModel)]="newTargetSize"></measurement-input>
            </mat-form-field>
            <div class="flex-column">
                <mat-label>Target Percentage Range (%)</mat-label>
                <div class="container pr-range">
                    <mat-slider min="0" max="100" step="1" discrete class="new-size">
                        <input matSliderStartThumb [(ngModel)]="newTargetMinPr">
                        <input matSliderEndThumb [(ngModel)]="newTargetMaxPr">
                    </mat-slider>
                </div>
            </div>
            <mat-icon class="add-size-btn" (click)="addCustomSizeRange()">add_circle_outline</mat-icon>
            <br />
        </div>
    </div>
    <button mat-raised-button color="primary" class="section container" (click)="saveSettings()" *ngIf="!enableSaving">
        Save Interval Settings
    </button>
</div>
